import discountCreated from "../events/discount-created.js";
import discountUpdated from "../events/discount-updated.js";
function makeEventRouter() {
    const router = {
        '': { execute: async () => { } }
    };
    const routerWithData = {
        'discount-created': discountCreated,
        'discount-updated': discountUpdated
    };
    return Object.freeze({
        get,
        getWithData
    });
    function get(action) {
        return router[action];
    }
    function getWithData(action) {
        return routerWithData[action];
    }
}
;
const APP_VIEWS = makeEventRouter();
export default APP_VIEWS;
